import(/* webpackMode: "eager", webpackExports: ["AlternativesCatalog"] */ "/vercel/path0/src/components/alternativesCatalog/alternativesCatalog.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlternativesHero"] */ "/vercel/path0/src/components/alternativesHero/alternativesHero.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reviews"] */ "/vercel/path0/src/components/numbers-and-reviews/reviews/reviews.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustedBy"] */ "/vercel/path0/src/components/trustedBy/trustedBy.comp.tsx");
